import { render, staticRenderFns } from "./PackageSelectorPills.vue?vue&type=template&id=2395df5c&scoped=true"
import script from "./PackageSelectorPills.vue?vue&type=script&setup=true&lang=js"
export * from "./PackageSelectorPills.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PackageSelectorPills.vue?vue&type=style&index=0&id=2395df5c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2395df5c",
  null
  
)

export default component.exports